import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

interface PatientInfos {
  nomNaissance?: string;
  prenomNaissance?: string;
  dateNaissance?: string;
  sexe?: string;
  ins?: string;
}

@Component({
  selector: 'app-compare-patient-infos',
  templateUrl: './compare-patient-infos.component.html',
  styleUrls: [
    './compare-patient-infos.component.scss',
    '../modal.fragment.scss'
  ]
})
export class ComparePatientInfosComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  public hmPatient: PatientInfos;
  public cdaPatient: PatientInfos;

  constructor() { }

  public initComparePatients(hmPatient: PatientInfos, cdaPatient: PatientInfos): void {
    this.hmPatient = hmPatient;
    this.cdaPatient = cdaPatient;
  }

  ngOnInit(): void {
  }

  public closeModal(choice = false): void {
    this.closeEmitter.emit(choice);
  }

}
